import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 公用js
import util from './assets/js/common'
Vue.config.productionTip = false
axios.defaults.baseURL = util.axios_base_url
Vue.use(VueAxios, axios)
Vue.use(ElementUI);
let loading = null
axios.interceptors.request.use(config => {
    // 配置请求头
    config.headers['timestamp'] = (new Date()).getTime();
    config.headers['access-key'] = (new Date()).getTime();
    config.headers['reqApp'] = 'CSRWeb';
    let hideloading=true;
    // if(config.method=="get"){
    //     showloading=!config.data;
    // }else if(config.method=="post"){
    //     showloading=config.showloading;
    // }
    hideloading=config.hideloading?config.hideloading:false;
    if(!hideloading){
        loading = Vue.prototype.$loading({
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

axios.interceptors.response.use((response)=> {
    if (loading) {
        loading.close()
    }
    const status = response.status
    if (status === 200 && (response.data.errcode == 0)) {
        return Promise.resolve(response)
    }
    else if(response.data.errcode == 402){
        let headers =response.headers
        window.location.href =headers['location']
    }
    else {
        return Promise.reject(response)
    }

    // let resp_status= response.status;
    // let resp_data= response.data;
    // if (resp_status === 200) {
    //     if (resp_data.errcode==402) {//用户未登录
    //         let headers =response.headers
    //         window.location.href =headers['location']
    //     }else if(resp_data.errcode==0) {//接口返回成功
    //         return Promise.resolve(response)
    //     }else {//提示错误信息，不应该在这里做
    //         util.errorMsg(resp_data.errmsg);
    //         // return Promise.reject(response)
    //         return Promise.resolve(response)
    //     }
    // }else {
    //     return Promise.reject(response)
    // }

},(error)=>{
    if (loading) {
        loading.close()
    }
    console.log(error)
    //未授权
    if (error.response.status === 401) {
        let headers =error.response.headers
        window.location.href =headers['location']
    }
    //未登录
    else if(error.response.status === 402){
        let headers =error.response.headers
        window.location.href =headers['location']
    }
})
Vue.prototype.$util = util
// 引入公用过滤器
import * as filters from './assets/js/filters.js'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
// 获取客服组
util.getServiceGroup()
util. getTree()
//通过路由属性index判断当前active状态的nav
router.beforeEach((to, from, next) => {
    let result = util.getNode(to.name)
    if (!result && to.name != 'noPermission' && sessionStorage.getItem('root')){
        router.push('/noPermission')
        return
    }
    let n1 = to.matched[0]?to.matched[0].props.default.index:'1'
    let n2 = to.matched[1]?to.matched[1].props.default.index:'1'
    let n3 = to.matched[2]?to.matched[2].props.default.index:'1'

    store.commit('updateNav',{n1,n2,n3})
    if(to.name == '工作台' && store.state.customerMsg.uId){
        let uId = store.state.customerMsg.uId
        let uType = store.state.customerMsg.uType?store.state.customerMsg.uType:1
        util.markRead(uId,uType)
    }
    next()
})
// 自定义指令 过滤特殊字符串
Vue.directive('filterSpecialChar', {
    update: function (el, {value,modifiers},vnode) {
        try {
            let newValue = value? value.replace( /[`~#$%^&*()\-=<>:"{}|,;'\\[\]·~#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/g, ""):'';

            if((value !== newValue) && (value != '')){
                util.warningMsg('不能输入特殊字符')
            }
            if(value !== newValue){
                // 原生input
                if(el.value){
                    el.value = newValue
                    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                }
                // element ui input
                else {
                    el.children[0].value = newValue
                    el.children[0].dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                }

            }

        } catch (e) {
            console.log(e)
        }
    }
})
let app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
